import type { LatLng } from "./types.js";

/** Google Maps search deep-link (address or lat,lng). */
export function externalMapSearchUrl(query: string): string {
  const q = encodeURIComponent(query.trim());
  return `https://www.google.com/maps/search/?api=1&query=${q}`;
}

export function externalMapSearchUrlFromLatLng(point: LatLng): string {
  return externalMapSearchUrl(`${point.lat},${point.lng}`);
}

/** Multi-stop directions deep-link (up to ~10 waypoints in Google Maps URLs). */
export function externalMapDirectionsUrl(stops: string[]): string | null {
  const cleaned = stops.map((s) => s.trim()).filter(Boolean);
  if (cleaned.length < 2) return cleaned[0] ? externalMapSearchUrl(cleaned[0]) : null;
  const origin = encodeURIComponent(cleaned[0]!);
  const destination = encodeURIComponent(cleaned[cleaned.length - 1]!);
  const waypoints =
    cleaned.length > 2
      ? cleaned
          .slice(1, -1)
          .map((s) => encodeURIComponent(s))
          .join("%7C")
      : "";
  const base = `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${destination}&travelmode=driving`;
  return waypoints ? `${base}&waypoints=${waypoints}` : base;
}

/** Structured address object → Google Maps query (Logistics driver surfaces). */
export function buildMapsUrlFromAddressRecord(address: Record<string, unknown>): string | null {
  const parts = ["line1", "line2", "city", "state", "postal_code", "zip"]
    .map((key) => address[key])
    .filter((v): v is string => typeof v === "string" && v.trim().length > 0)
    .join(", ");
  const query =
    parts ||
    (typeof address.formatted === "string" && address.formatted.trim() ? address.formatted.trim() : "");
  if (!query) return null;
  return `https://maps.google.com/?q=${encodeURIComponent(query)}`;
}
